<template>
  <section 
    :class="[
      'mast',
      'container',
      {
        'mast-intro': !introComplete
      }
    ]"
  >
    <!-- <Navbar /> -->
    <Stage v-on:introComplete="onAfterIntroComplete" />
    <div class="text" v-if="introComplete">
      <h1 v-scrollanim> 
        문자에 재미를 더하다
      </h1>
      <svgLogo class="mast-logo" v-scrollanim />
      <p v-scrollanim>
        이제는 문자 메시지에서도 마음껏 이모티콘을 써보세요.<br>
        메신저 앱을 켜지 않아도, 데이터가 없어도,<br class="br-sm"> 언제 어디서나 다양한 이모티콘으로 답장해보세요.
      </p>
      <button class="btn-download" v-scrollanim v-on:click="copyToClipboard">
        공유하기
      </button>
    </div>
  </section>
</template>

<script>
import Stage from '@/components/stage/Stage'
import svgLogo from "@/svg/svgLogoAltBig"

export default {
  data() {
    return {
      introComplete: false
    }
  },
  methods: {
    onAfterIntroComplete() {
      this.introComplete = true
      console.log('complete')
    },
    copyToClipboard() {
      this.$emit('copyToClipboard')
    }
  },
  components: {
    Stage,
    svgLogo,
  }
}
</script>

<style lang="scss" scoped>

section.mast {
  position: relative;
  width: 100%;
  height: 985px;
  background-color: black;
  color: white;
  // padding-top: 56px;
  padding: 56px 0 0;
  @media screen and (max-width: 600px) {
    height: auto;
    padding: 56px 0;
    &.mast-intro {
      min-height: 951px;
    }
  }
  @media screen and (max-width: 580px) {
    &.mast-intro {
      min-height: 836px;
    }
  }
  @media screen and (max-width: 420px) {
    &.mast-intro {
      min-height: 756px;
    }
    .text {
      margin-top: -40px;
    }
  }
}

h1 {
  margin: 40px auto 0;
  font-weight: 500;
  font-size: 46px;
  text-align: center;
  letter-spacing: -2%;
  @media screen and (max-width: 768px) {
    font-size: 40px;
    margin: 20px auto 0;
  }
  @media screen and (max-width: 600px) {
    font-size: 34px;
  }
}
.mast-logo {
  display: block;
  width: auto;
  height: 40px;
  margin: 39px auto 20px;
  &:deep path {
    fill: white;
  }
  @media screen and (max-width: 600px) {
    margin: 20px auto 20px;
    height: 34px;
  }
}

p {
  color: #D3D3D3;
  font-size: 16px;
  margin: 0 auto;
  font-weight: 400;
  padding: 0 12px;
  max-width: 620px;
  line-height: 1.5;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }     
}
button.btn-download {
  display: block;
  padding: 0 48px;
  height: 50px;
  border-radius: 10px;
  background: #3B7CF3;
  color: white;
  font-size: 20px;
  font-weight: 500;
  margin: 50px auto;
  border: 0;
  outline: 0;
  cursor: pointer;
  @media screen and (max-width: 600px) {
    margin: 30px auto;
  }
}

// Anims

h1.before-enter {
  transform: translate3d(0, 30%, 0);
  opacity: 0;
}
h1.enter {
  transform: translate3d(0, 0%, 0);
  opacity: 1;
  transition: 450ms ease-in-out opacity, 750ms ease-in-out transform;
  transition-delay: 0;
}

.mast-logo.before-enter {
  transform: translate3d(0, 30%, 0);
  opacity: 0;
}
.mast-logo.enter {
  transition: 450ms ease-in-out opacity, 500ms ease-in-out transform;
  transition-delay: 200ms;
  transform: translate3d(0, 0%, 0);
  opacity: 1;
}

p.before-enter {
  transform: translate3d(0, 30%, 0);
  opacity: 0;
}
p.enter {
  transition: 450ms ease-in-out opacity, 500ms ease-in-out transform;
  transition-delay: 400ms;
  transform: translate3d(0, 0%, 0);
  opacity: 1;
}

.btn-download.before-enter {
  // transform: translate3d(0, 30%, 0);
  opacity: 0;
}
.btn-download.enter {
  transition: 450ms ease-in-out opacity, 500ms ease-in-out transform;
  transition-delay: 600ms;
  opacity: 1;
}






</style>
